import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import Text from "../../elements/Text";

const calcPerc = (currentTime: number, duration: number) => {
  return (currentTime / duration) * 100;
};

const calcSeconds = (width: number, pos: number, duration: number) => {
  return Math.floor((pos / width) * duration);
};

const minMax = (min: number, max: number, value: number) => {
  if (value > max) {
    return max;
  }
  if (value < min) {
    return min;
  }
  return value;
};

const formatSeconds = (seconds: number): string => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(":");
};

const Container = styled.div`
  flex: 1 1;
  margin-left: 32px;
  padding-top: 19px;
  position: relative;
`;

const BarOuter = styled.div`
  position: relative;
  height: 3px;
  width: 100%;
  border-radius: 1px;
  background-color: ${select.color(["grey", 2])};
  cursor: pointer;
  overflow: hidden;
`;

const BarInner = styled.div`
  height: 100%;
  background-color: ${select.color(["primary", 3])};
`;

const Circle = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: absolute;
  background-color: ${select.color(["primary", 5])};
  /* pointer-events: none; */
  transform: translate(-50%, -9px);
  cursor: pointer;

  &:hover {
    background-color: ${select.color(["primary", 6])};
  }
  &:active {
    background-color: ${select.color(["primary", 6])};
  }
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

type Props = {
  currentTime: number;
  duration: number;
  onTimeChange: (seconds: number) => void;
};

class TimeBar extends React.Component<Props> {
  mouseDown: boolean = false;
  bar = React.createRef<HTMLDivElement>();

  state = {
    tmpTime: null
  };

  handleMouseDown = (evt: any) => {
    evt.stopPropagation();
    this.mouseDown = true;

    document.addEventListener("mousemove", this.handleMove);
    document.addEventListener("mouseup", this.handleUp);
  };

  handleUp = (evt: any) => {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMove);
    document.removeEventListener("mouseup", this.handleUp);

    this.setState({ tmpTime: null }, () => {
      this.props.onTimeChange(this.getCurrentTimeFromPos(evt.clientX));
    });
  };

  getCurrentTimeFromPos = (x: number) => {
    const { width, left } = this.bar.current!.getBoundingClientRect();

    const { duration } = this.props;

    return minMax(0, duration, calcSeconds(width, x - left, duration));
  };

  handleMove = (evt: any) => {
    this.setState({
      tmpTime: this.getCurrentTimeFromPos(evt.clientX)
    });
  };

  render() {
    const { currentTime, duration } = this.props;
    const { tmpTime } = this.state;

    const pos = `${calcPerc(tmpTime || currentTime, duration)}%`;

    return (
      <Container>
        <BarOuter ref={this.bar} onMouseDown={this.handleMouseDown}>
          <BarInner style={{ width: pos }} />
        </BarOuter>
        <Circle style={{ left: pos }} onMouseDown={this.handleMouseDown} />
        <Bottom>
          <Text c={["grey", 5]} fs={-2}>
            {formatSeconds(tmpTime || currentTime)}
          </Text>
          <Text c={["grey", 5]} fs={-2}>
            {formatSeconds(duration)}
          </Text>
        </Bottom>
      </Container>
    );
  }
}

export default TimeBar;
